import { Route, Routes } from 'react-router-dom';
import Home from './page/home/Home';
import Store from './page/store/Store';
import Nav from './component/nav/Nav';
import { useEffect, useState } from 'react';
import Aboutme from './page/aboutme/Aboutme';
import Loading from './component/loading/Loading';
import Employment from './page/employment/Employment';
import Adminpage from './page/admin/Adminpage';
import Showstory from './component/showstory/Showstory';
import './index.css'
import Eduction from './page/eduction/Eduction';
import Production from './page/production/Production';
import 'leaflet/dist/leaflet.css'
import Update from './page/update/Update';
import Language from './component/language/Language';
import Brand from './page/brand/Brand';
import Contact from './page/contant/Contact';
import Catalog from './page/catalog/Catalog';
import Mugram from './page/mugram/Mugram';
import Downloadapp from './component/downloadapp/Downloadapp';

function App() {
  const [opensearch, setOpensearch] = useState(false)
  const [selectnav, setSelectnav] = useState(window.location.pathname)
  const [loading, setLoading] = useState(true)
  const [loadingnumber, setLoadingnumber] = useState(0)
  const [searchvalue, setSearchvalue] = useState()
  const [idstory, setIdstory] = useState()
  const [showstorybox, setShowstorybox] = useState(false)
  const [storyend, setStoryend] = useState(0)
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const [language , setLanguage] = useState('fa')
  const [close , setClose] = useState(false)
  useEffect(() => {
    const loadinginterval = setInterval(() => {
      loadingnumber < 100 ? setLoadingnumber(loadingnumber + 1) : setLoading(false)
    }, 7)
    return () => clearInterval(loadinginterval)
  }, [loadingnumber])

  const searching = (e) => {
    setSearchvalue(e.target.value)
  }

  const [stories, setStories] = useState([]);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const response = await fetch('http://185.164.73.170:5000/api/stories');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setStories(data || []);
      } catch (error) {
        console.error("Failed to fetch stories:", error);
      }
    };
    fetchStories();
  }, []);

  const addStory = (newStory) => {
    setStories([...stories, newStory]);
  };

  const removeStory = async (id) => {
    try {
      const response = await fetch(`http://185.164.73.170:5000/api/stories/${id}`, {
        method: 'DELETE'
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setStories(stories.filter(story => story.id !== id));
    } catch (error) {
      console.error("Failed to delete story:", error);
    }
  };
  function showstory(id) {
    setIdstory(id);
    setShowstorybox(true);
    setStoryend(0);
  }
  useEffect(() => {
    let endstory;
    if (showstorybox) {
      endstory = setInterval(() => {
        setStoryend((prevStoryend) => {
          if (prevStoryend < 100) {
            return prevStoryend + 1;
          } else {
            clearInterval(endstory);
            setShowstorybox(false);
            return prevStoryend;
          }
        });
      }, 25);
    }

    return () => {
      clearInterval(endstory);
    };
  }, [showstorybox]);
  useEffect(() => {
    const socket = new WebSocket('ws://185.164.73.170:4000');

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setOnlineUsers(data.onlineUsers);
    };

    return () => {
      socket.close();
    };
  }, []);

  useEffect(() => {
    fetch('http://185.164.73.170:5000/api/status')
        .then(response => response.json())
        .then(data => {
            setIsUpdating(data.updateStatus);
        })
        .catch(error => {
            console.error('Error fetching update status:', error);
        });
}, []);


  return (
    <>
      <Loading loading={loading} loadingnumber={loadingnumber} setLoadingnumber={setLoadingnumber} setLoading={setLoading} />
      <Update isUpdating={isUpdating}/>
      <div style={loading || (isUpdating && window.location.pathname !== '/admin') ? { display: 'none' } : { display: 'block' }}>
      <Nav language={language} setLanguage={setLanguage} onlineUsers={onlineUsers} selectnav={selectnav} setSelectnav={setSelectnav} />
        <Showstory storyend={storyend} showstorybox={showstorybox} setShowstorybox={setShowstorybox} idstory={idstory} stories={stories} />
        <Language language={language} setLanguage={setLanguage}/>
        <Downloadapp close={close} setClose={setClose} language={language} />
        <Routes>
          <Route path='/' element={<Home language={language} setSelectnav={setSelectnav} showstory={showstory} stories={stories} opensearch={opensearch} setOpensearch={setOpensearch} />} />
          <Route path='/store' element={<Store language={language} searching={searching} searchvalue={searchvalue} opensearch={opensearch} setOpensearch={setOpensearch} />} />
          <Route path='/aboutme' element={<Aboutme language={language} selectnav={selectnav} setSelectnav={setSelectnav} />} />
          <Route path='/employment' element={<Employment selectnav={selectnav} setSelectnav={setSelectnav} />} />
          <Route path='/contact' element={<Contact selectnav={selectnav} setSelectnav={setSelectnav} />} />
          <Route path='/eduction' element={<Eduction />}/>
          <Route path='/brand' element={<Brand language={language} />}/>
          <Route path='/catalog' element={<Catalog language={language} />}/>
          <Route path='/mugram' element={<Mugram language={language} showstory={showstory} stories={stories} />}/>
          <Route path='/production' element={<Production language={language} setSelectnav={setSelectnav} />}/>
          <Route path='/admin' element={<Adminpage addStory={addStory} stories={stories} removeStory={removeStory} />} />
        </Routes>
        <div className="leaves">
                {Array.from({ length: 20 }).map((_, index) => (
                    <div key={index} className="leaf"></div>
                ))}
            </div>
      </div>
    </>
  );
}

export default App;  